import React from 'react';
import {
  CalendarClock,
  CheckSquare,
  RotateCcw,
  TimerOff,
  UserCheck,
} from 'lucide-react';

import PageGuide from '../../workspace/PageGuide';
import { POTENTIAL_LEGEND } from './signingUpUtils';

// How Signing Up works (Nic 2026-09-29; the lane-era modal became the
// left-hand panel on 2026-10-29): the things a rep has to know about the
// desk, then the details. The day windows mirror CHECKPOINTS in
// server/lib/potentialClients.js (fixed in code); change both together. The
// colors come from the board's own key (POTENTIAL_LEGEND), so they never
// drift.
const SECTIONS = [
  {
    tone: 'sky',
    icon: CheckSquare,
    title: 'Your move today is your list',
    text: 'The number, the filter and Today are the same to-dos. Doing it clears it on its own; a tick holds it for today.',
  },
  {
    tone: 'amber',
    icon: CalendarClock,
    title: 'Every step has a clock',
    text: 'Business days from when the step started. Miss it and they go to Nurture that night. Next says the day.',
    facts: ['Business days', 'Nurture that night'],
  },
  {
    tone: 'rose',
    icon: TimerOff,
    title: 'Only a step buys time',
    text: "A nudge, a check-in or their text never does. A meeting ahead pauses the clock; a no-show doesn't.",
  },
  {
    tone: 'violet',
    icon: RotateCcw,
    title: "Nurture isn't the end",
    text: 'Anyone can re-engage them, and if they reach out they are flagged.',
  },
  {
    tone: 'slate',
    icon: UserCheck,
    title: 'Your leads are yours',
    text: "Nobody else acts on them, and you don't act on anyone else's. A manager can look at anything and reassign it.",
  },
];

// What each color asks of the rep, in the key's order (blue, yellow, red).
const COLOR_MEANS = [
  'A meeting ahead, or their move',
  'Book, sign up, or nudge on their last day',
  'Send the agreement',
];

const STEPS = {
  title: 'The windows',
  text: 'Business days after the step starts. Weekends and days off never count.',
  items: [
    {
      name: 'Follow-up, nothing booked',
      value: 'Same day',
      dot: 'bg-teal-500',
    },
    {
      name: 'Missed the meeting',
      value: '1 day to rebook',
      dot: 'bg-teal-500',
    },
    { name: 'After the meeting', value: 'Same day', dot: 'bg-teal-500' },
    { name: 'Signup link sent', value: '2 days', dot: 'bg-indigo-500' },
    { name: 'Account made', value: '1 day', dot: 'bg-indigo-500' },
    { name: 'Agreement sent', value: '3 days', dot: 'bg-indigo-500' },
  ],
};

const NOTES = [
  {
    title: 'The one nudge',
    text: 'On their last day in Signup link sent or Agreement sent, one text is your part. It never adds time.',
  },
  {
    title: 'Account made never goes to Nurture',
    text: 'They are waiting on us. Past its day it turns overdue and loud instead.',
  },
  {
    title: 'Nurture tonight',
    text: 'The counter lists everyone the first sweep after midnight moves. A meeting tomorrow or later holds them.',
  },
];

const SigningUpGuide = () => (
  <PageGuide
    title="Signing Up"
    sections={SECTIONS}
    colors={POTENTIAL_LEGEND.map((c, i) => ({
      label: c.label,
      fill: c.fill,
      means: COLOR_MEANS[i],
    }))}
    steps={STEPS}
    notes={NOTES}
  />
);

export default SigningUpGuide;
